export default class RandomPicker {
  constructor(array) {
    this.originalArray = [...array]; // Исходный массив
    this.availableItems = [...array]; // Копия для работы
  }

  getRandomItem() {
    if (this.availableItems.length === 0) {
      console.log("Все элементы использованы! Сбрасываем список...");
      this.reset(); // Сбрасываем список
    }

    const randomIndex = Math.floor(Math.random() * this.availableItems.length);
    const item = this.availableItems.splice(randomIndex, 1)[0]; // Удаляем и возвращаем элемент
    return item;
  }

  reset() {
    this.availableItems = [...this.originalArray]; // Восстанавливаем копию массива
  }
}
